<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <!-- 用户信息 -->
      <el-form :model="form" :rules="rules" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_languageKey_tree_dialog.suo_shu_ying_yong')" prop="appId">
              <el-select v-model="appName" disabled :placeholder="$t('Common.com_please_select')"></el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_languageKey_tree_dialog.shang_ji_fen_zu')" prop="parentId">
              <custom-select
                v-model="form.parentId"
                :placeholder="$t('Common.com_please_select')"
                :props="{
                  label: 'name',
                  value: 'id',
                  checkStrictly: true,
                  emitPath: false,
                }"
                url="LanguageKeyGroupTree"
                type="tree"
                :show-all-levels="false"
                :listener="form.langKeyId"
                :params="{ langKeyId: form.langKeyId, appId: form.appId }"
              ></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_languageKey_tree_dialog.fen_zu_ming_cheng')" prop="langKeyName">
              <el-input v-model="form.langKeyName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_languageKey_tree_dialog.fen_zu_dai_ma')" prop="langKeyCode">
              <el-input v-model="form.langKeyCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_languageKey_tree_dialog.mo_ren_zhi')" prop="defaultValue">
              <el-input v-model="form.defaultValue"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_languageKey_tree_dialog.fen_zu_miao_shu')" prop="langKeyDesc">
              <el-input :rows="3" type="textarea" v-model="form.langKeyDesc"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveLangTree">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      appName: '',
      form: {
        langKeyId: '',
        appId: '',
        parentId: null,
        langKeyName: '',
        langKeyCode: '',
        langKeyDesc: '',
        defaultValue: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        appId: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        langKeyName: [
          {
            required: true,
            message: this.$t('base_languageKey_tree_dialog.fzmcbt'),
          },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]), },
        ],
        langKeyCode: [
          {
            required: true,
            message: this.$t('base_languageKey_tree_dialog.fzdmbt'),
          },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]), },
        ],
        defaultValue: [
          {
            required: true,
            message: this.$t('base_languageKey_tree_dialog.mo_ren_zhi_bi_tian'),
          },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]), },
        ],
        langKeyDesc: { max: 100, message: this.$t('Common.com_rules_length_max', [100]), },
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.appName = this.model.data.appName;
      if (this.model.type === 'edit') {
        this.$setFormatData(this.form, this.model.data.row);
      } else if (this.model.type === 'add') {
        this.form.appId = this.model.data.appId;
        this.form.parentId = this.model.data.parentId || null;
      }
    },
    // 确认保存
    saveLangTree: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'edit') {
          this.saveEditLang();
        } else if (this.model.type === 'add') {
          this.saveAddLang();
        }
      });
    },
    // 新增
    saveAddLang: function () {
      this.$postJSON(apis.LanguageKeyGroupAdd, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 保存编辑分组
    saveEditLang: function () {
      this.$postJSON(apis.LanguageKeyGroupUpdate, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 下拉树配置
    normalizer(node) {
      return {
        id: node.id,
        label: node.name,
        value: node.id,
      };
    },
  },
};
</script>

<style lang="scss"></style>
